// Notification.jsx
import React, { useState } from 'react';
import { Toast } from 'react-bootstrap';
import PropTypes from 'prop-types';

export default function Notification({ type, title, message, date, delay, onClosed }) {
  const [toastState, setToastState] = useState(true);

  const handleClose = () => {
    if (toastState !== false) setToastState(false);
    // avisa o provider pra remover a notificação do array
    onClosed?.();
  };

  const defaultBodyClass = 'card-text fw-bolder text-break';

  // mapeia tipos "semânticos" para variantes Bootstrap
  const variantMap = { error: 'danger', loading: 'secondary' };
  const variant = (variantMap[type] || type || 'danger').toLowerCase();

  const bodyTextClass = ['dark', 'danger', 'primary', 'success', 'secondary'].includes(variant)
    ? `${defaultBodyClass} text-white`
    : defaultBodyClass;

  return (
    <Toast
      show={toastState}
      onClose={handleClose}
      delay={delay}
      bg={variant}
      autohide={type !== 'loading'} // <- não some sozinho quando está carregando
    >
      <Toast.Header>
        <span className={`dot bg-${variant} me-2`} />
        <div className="card-heading text-dark me-auto">{title} </div>
        <small>{date}</small>
      </Toast.Header>

      <Toast.Body className={bodyTextClass}>{message}</Toast.Body>
    </Toast>
  );
}

Notification.defaultProps = {
  type: 'danger',
  title: 'Aviso',
  date: new Date().toLocaleTimeString(),
  delay: 15000,
  onClosed: undefined,
};

Notification.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  type: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  delay: PropTypes.number,
  onClosed: PropTypes.func,
};
